module.exports = __webpack_public_path__ + "img/p7.3b186cb6.png";